<template>
  <div>
    <div>
      <div class="sheet-bbody">
        <!-- <div class="step-title">Step 1 of 2</div> -->
        <div v-if="flow == 1">
          <div class="step-h">
            Enter Vehicle Registration Number to Map Charger Session.
          </div>
          <div class="search-field">
            <label>Vehicle Registration Number
              <span class="required">*</span>
            </label>
            <input
              v-model="options.registration_no"
              type="text"
              placeholder="KGH-67788"
              inputmode="text"
              required
            >
            <p class="text-red">
              {{ error?.registration_no }}
            </p>
          </div>
          <!-- <div class="or-divider">OR</div> -->
          <div class="search-field">
            <label>Customer Name</label>
            <input
              v-model="options.customer_name"
              placeholder=""
              type="text"
            >
          </div>
          <div class="search-field">
            <label>Customer Email</label>
            <input
              v-model="options.email"
              placeholder=""
              type="email"
            >
          </div>
          <div class="search-field">
            <label>Customer Phone Number</label>
            <input
              v-model="options.cusotmer_number"
              placeholder="+92XXXXXXXXXX"
              :maxlength="13"
              type="text"
            >
          </div>
          <!-- on search -->
          <div>
            <v-btn
              color="primary"
              class="big-btn btn-primary"
              height="4.5rem"
              :loading="loading"
              :disabled="!options.registration_no"
              @click="onSearch"
            >
              Search
              <v-icon
                color="white"
                class="ml-3"
              >
                mdi-arrow-right
              </v-icon>
            </v-btn>
            <div class="helper-text">
              Ask the customer for either one
            </div>
          </div>
        </div>

        <!--  Complete walk In -->
        <div v-else-if="flow == 2">
          <div class="sheet-body">
            <div class="success-wrap">
              <div class="success-ring success-ring--green">
                <v-icon>mdi-check</v-icon>
              </div>
              <h2>Session mapped successfully</h2>
              <span class="msg">
                User status:
                <span :class="res?.is_registered == false ? 'text-red' : ''">
                  {{ res?.is_registered ? "Registered" : "Unregistered" }}
                </span>
              </span>
            </div>
          </div>
          <div>
            <button
              class="big-btn btn-primary"
              @click="$emit('close')"
            >
              Back to Bookings
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      loading: false,
      flow: 1,
      options: {},
      error: {
        registration_no: "",
      },
      res: {},
    };
  },
  mounted() {},
  methods: {
    async onSearch() {
      const params = {
        ...this.options,
        csms_charging_sessions_id: this.item.id,
        charger_connector_id: this.item.charger_connector_id,
        charge_point_id: this.item.charge_point_id,
      };
      // Validation On Registration Number
      const regx = /^[A-Za-z]{1,4}-\d{3,4}$/; // for Search Reg No
      if (params.registration_no && !regx.test(params.registration_no)) {
        this.error.registration_no = "Reg Number is not valid";
        this.$store.dispatch(
          "alerts/error",
          "Vehicle regisrtation number is not valid"
        );
        return;
      }
      // Validation On Registration Number
      this.loading = true;
      this.error = {};
      await this.$store
        .dispatch("bookingOperator/mapWalkInCustomer", params)
        .then((res) => {
          this.$store.dispatch("alerts/success", "Session Map Successfully");
          this.flow = this.flow + 1;
          this.res = res;
          // this.$emit("close");
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
<style scoped>
.sheet-body {
  height: 60vh;
}

.text-red {
  color: var(--red);
}
</style>
